import { FC, SVGProps } from "react";

const Realtor: FC<SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            width="1200"
            height="1227"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            <path
                d="M22 12.712 12.01 2.5 2 12.712h3.053v9.163h13.9v-9.163H22Z"
                fill="#D92228"
            />
            <path
                d="M15.821 10.036c-.263-.262-.685-.406-1.193-.406-.838 0-1.365.347-1.728.649l-.007.006c-.362.348-.778.82-1.12 1.739l.02-.938c.013-.512.02-.951.02-1.004 0-.111-.08-.23-.252-.23h-3.25v.276l.085.007c.264.02.515.046.745.21.205.137.33.327.37.57.066.282.066 1.109.066 1.463v4.69c0 .478-.014 1.134-.086 1.573-.132.427-.27.558-.554.702a1.967 1.967 0 0 1-.58.151l-.093.007v.275h4.854v-.275l-.086-.007a1.63 1.63 0 0 1-.54-.131c-.146-.052-.271-.184-.403-.426-.191-.407-.31-.866-.31-1.981V15c0-.59.027-1.16.046-1.41.218-1.56 1.069-2.814 1.622-2.814.211 0 .35.23.502.597.178.42.428.866 1.147.866.712 0 1.088-.597 1.088-1.194.007-.406-.112-.734-.363-1.01Z"
                fill="#fff"
            />
        </svg>
    );
};

export default Realtor;
